/* eslint-disable no-script-url */
import React from 'react';

import { Grid, makeStyles, Typography } from '@material-ui/core';
import moment from 'moment';

import CaseStatusCell from '../cases/CaseStatusCell';

const useStyles = makeStyles((theme) => {
  return {
    field: {
      marginBottom: '1rem',
    },
    fieldTitle: {
      color: '#172B4D',
      fontWeight: 'bold',
    },
    fieldValue: {
      color: '#999999',
      lineHeight: '2rem',
    },
    link: {
      color: theme.palette.primary.main,
      fontWeight: '400',
      textDecoration: 'none',
    },
    workspaceField: {
      color: theme.palette.primary.main,
    },
  };
});

const translateReportType = (reportType) => {
  if (!reportType) return '-';
  const translatedReportType = {
    express: 'Express Report (48 hours)',
    standard: 'Standard Report (5 days)',
  };

  return translatedReportType[reportType.toLowerCase()];
};

export default ({ caseStudy, onOpenReportViewer }) => {
  const classes = useStyles();
  const gender = caseStudy.patient && caseStudy.patient.gender ? caseStudy.patient.gender[0].toUpperCase() + caseStudy.patient.gender.slice(1) : 'N/A';

  const caseValues = {
    Assignee: caseStudy.assigneeName,
    "Claimant's Employer": caseStudy.patient.employer,
    "Claimant's Gender": gender,
    "Claimant's Name": caseStudy.patient.name,
    'Date of Birth': caseStudy.patientDateOfBirth && moment.parseZone(caseStudy.patientDateOfBirth).format('MM/DD/YY'),
    Gender: gender,
    'Patient Name': caseStudy.patientName,
    'Preferred Name': caseStudy.patientPreferredName,
    'Preliminary Date': caseStudy.patient.preliminaryDate ? moment.parseZone(caseStudy.patient.preliminaryDate).format('MM/DD/YY') : 'No data',
    Product: translateReportType(caseStudy?.reportType),
    'Radiology Report': caseStudy?.reports?.length ? (
      <a className={classes.link} href="javascript:void(0)" onClick={() => onOpenReportViewer(caseStudy?.reports)}>
        Link
      </a>
    ) : null,
    Reviewer: caseStudy.reviewerName,
    'Uploaded Date': moment(caseStudy.createdAt).format('MM/DD/YY'),
    Workspace: caseStudy.workspaceName,
  };

  const renderDataField = (title, value) => {
    return (
      <Grid key={title} item className={classes.field}>
        <Typography className={classes.fieldTitle}>{title}</Typography>
        <Typography className={`${classes.fieldValue} ${title === 'Workspace' ? classes.workspaceField : ''}`}>{value || 'N/A'}</Typography>
      </Grid>
    );
  };

  const renderFields = () => {
    const infoCategories = caseStudy.isLawFirmCase
      ? [
          "Claimant's Name",
          "Claimant's Gender",
          'Date of Birth',
          'Preliminary Date',
          "Claimant's Employer",
          'Workspace',
          'Uploaded Date',
          'Assignee',
          'Reviewer',
          'Radiology Report',
        ]
      : ['Product', 'Patient Name', 'Preferred Name', 'Gender', 'Date of Birth', 'Workspace', 'Uploaded Date', 'Assignee', 'Reviewer', 'Radiology Report'];

    return infoCategories.map((key) => renderDataField(key, caseValues[key]));
  };
  return (
    <Grid container direction="column" alignItems="flex-start" style={{ textAlign: 'left' }}>
      <Grid item className={classes.field} style={{ width: '100%' }}>
        <CaseStatusCell status={caseStudy.status.label} color={caseStudy.statusColor} maxWidth="150px" width="100%" height="30px" />
      </Grid>
      {renderFields()}
    </Grid>
  );
};
